import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import useUserStore from "../../../../../utils/storeApp";
import CallAPI from "../../../../../services/apiCalls";
import { Column } from "primereact/column";
import $ from "jquery";
import { useReactToPrint } from "react-to-print";
import ReportsDropdown from "../../ReportsDropdown";
import { CSVLink } from "react-csv";
import SharedMsg from "../../../SharedMsg";

const ListUserDeleteActivity = () => {
  const navigate = useNavigate();
  const { isUserLogedIn, userRole, userToken, sharedObject, SetSharedObject } =
    useUserStore((state) => ({
      isUserLogedIn: state.isUserLogedIn,
      userRole: state.userRole,
      userToken: state.userToken,
      sharedObject: state.sharedObject,
      SetSharedObject: state.SetSharedObject,
    }));
  const [userObj, setUserObj] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [count, setCount] = useState(0);
  const [reportName, setReportName] = useState(false);
  const [refreshObj, SetRefreshObj] = useState(false);
  const [processing, SetProcessing] = useState(false);

  useEffect(() => {
    let obj = sharedObject.UserActiviySearch;
    if (obj && Object.keys(obj).length > 0) {
      // setLast(obj.count < 25 ? obj.count : 25);
      console.log(obj);
      gridData(obj);
    }
  }, [sharedObject.UserActiviySearch]);

  const getReport = async (src, pg) => {
    SetProcessing(true);
    let call =
      "/reports/DeleteActivity?searchPhrase=''&sortDir=userNameDisplay&sortBy=userNameDisplay&current=" +
      pg;
    SetRefreshObj(src);
    const res = await CallAPI(call, src, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      const ob = {
        pageItems: res.data.data.pageItems,
        ReportTypeVal: src.ReportedUserEvent,
        OrgName: src.OrganizationName,
      };
      gridData(ob);
      SetProcessing(false);
    } else {
      SetProcessing(false);
    }
  };
  const gridData = (obj) => {
    // let cnt = obj.count;
    // setCount(cnt);
    setReportName(obj.ReportTypeVal);
    let tempObj = [];
    for (const row of obj.pageItems) {
      row.OrgName = obj.OrgName;
      let nt = row.mechanism.split("~");
      row.UName = nt.length > 1 ? nt[1] : row.note;
      tempObj.push(row);
    }
    setUserObj(tempObj);
    let reportName = obj.ReportTypeVal;
    let s =
      reportName !== "UserAccountDeleted"
        ? { label: "Direct Email", key: "eventValue" }
        : false;
    let u =
      reportName === "OrganizationEmailDeleted"
        ? { label: "Organization", key: "organizationName" }
        : {
            label: "Username",
            key: reportName === "UserAccountDeleted" ? "eventValue" : "UName",
          };

    const hds = [
      { label: "Domain", key: "eventDomain" },
      { label: "Reason", key: "Note" },
      { label: "Deleted", key: "timeStamp" },
      { label: "Deleted By", key: "actor" },
    ];
    if (s !== false) {
      setHeaders([s, u, ...hds]);
    } else {
      setHeaders([u, ...hds]);
    }
  };

  const deletedDate = (dt) => {
    return dt.timeStamp
      ? new Date(dt.timeStamp).toLocaleString("en-US", { hour12: false })
      : null;
  };
  const UserNameDisplay = (val) => {
    return reportName === "UserAccountEmailDeleted"
      ? val.UName.split("|")[0]
      : val.eventValue;
  };
  const [first, setFirst] = useState(1);
  const [last, setLast] = useState(25);
  const [rows, setRows] = useState(25);
  const onPageChange = (event) => {
    setFirst(event.first + 1);
    setRows(event.rows);
    let lastNr = event.first + 25;
    let last = lastNr > count ? count : lastNr;
    setLast(last);
    let page = event.page + 1;
    SetRefreshObj(sharedObject.userDeleteActivity);
    getReport(sharedObject.userDeleteActivity, page);
  };
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const refreshPage = () => {
    setFirst(1);
    setLast(25);
    getReport(sharedObject.userDeleteActivity, 1);
  };

  const bulkDownLoad = () => {
    SetSharedObject("UserDelsteType", "bulk");
    $("#deleteActivitySearchModal").modal("show");
  };

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  return (
    <main ref={componentRef} className="ListUserDeleteActivity">
        <header>
            <div className="spacer-inline sp-margin12">
              <h4 className="title-label3">
                Delete
                {sharedObject?.UserActiviySearch?.ReportTypeVal ===
                "UserAccountEmailDeleted"
                  ? " User Email"
                  : sharedObject?.UserActiviySearch?.ReportTypeVal ===
                    "OrganizationEmailDeleted"
                  ? " Organization Email"
                  : sharedObject?.UserActiviySearch?.ReportTypeVal ===
                    "UserAccountDeleted"
                  ? " User"
                  : ""}{" "}
                Activity
            </h4>
            </div>

          <div className="mid-header-bar spacer-inline sp-mx5">
            <ReportsDropdown />
            <button
              className="btn btn-outline-dark sp-margin5 btn-reports-sm"
              data-toggle="modal"
              aria-label="Open delete activity search"
              aria-haspopup="dialog"
              onClick={(e) => {
                SetSharedObject("UserDelsteType", "reg");
                $("#deleteActivitySearchModal").modal("show");
              }}
            >
              <i className="bi bi-search" aria-hidden="true"></i>
            </button>

            <button
              className="btn btn-outline-dark sp-margin5 btn-reports-sm"
              aria-label="Open bulk download delete activity search"
              aria-haspopup="dialog"
              data-toggle="modal"
              onClick={(e) => {
                bulkDownLoad();
              }}
            >
              <i className="bi bi-box-arrow-down" aria-hidden="true"></i>
            </button>

            <div className="spacer-inline" role="toolbar" aria-label="Delete activity report export and refresh tools">
                <span className="SharedTools" role="group" aria-label="Export and print tools">
                    {userObj.length > 0 ? (
                      <CSVLink
                        filename="ListUserDeleteActivity.csv"
                        className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                        aria-label="Download delete activity as MS Excel CSV file"
                        data={userObj}
                        headers={headers}
                      >
                        <i className="bi bi-download" aria-hidden="true"></i>
                      </CSVLink>
                    ) : (
                      <button
                            type="button"
                            className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                            disabled
                            aria-disabled="true"
                            aria-label="Download CSV (no results available)"
                          >
                            <i className="bi bi-download" aria-hidden="true"></i>
                       </button>
                    )}

                  <button
                    type="button"
                    className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                    disabled={userObj.length === 0} 
                    aria-disabled={userObj.length === 0}
                    aria-label={
                          userObj.length === 0
                            ? "Refresh report (no results to refresh)"
                            : "Refresh report"
                        }
                    onClick={(e) => {
                      if (userObj.length > 0) refreshPage();
                    }}
                  >
                    <i className="bi bi-arrow-clockwise" aria-hidden="true"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                    disabled={userObj.length === 0} 
                    aria-disabled={userObj.length === 0}
                    aria-label={
                      userObj.length === 0
                        ? "Print report (no results to print)"
                        : "Print received messages report"
                    }
                    onClick={(e) => {
                      if (userObj.length > 0) handlePrint();
                    }}
                  >
                    <i className="bi bi-printer" aria-hidden="true"></i>
                  </button>
               </span>
            </div>
          </div>
        </header>

      <div>
        <section className="grid-header-bar"  aria-label="Report filter summary">
          {userRole !== "SES ADMINISTRATOR" &&
          userRole !== "SYSTEMADMINISTRATOR" ? null : (
            <>
              <dl className="sp-mx7 ">
                <div className="spacer-inline spacer-margin1">
                    <dt className="ft-wt">Domain:</dt>
                    <dd className="sp-margin12 sp-mx7">
                      {sharedObject?.userDeleteActivity?.DomainName
                        ? sharedObject?.userDeleteActivity?.DomainName
                        : null}
                    </dd>
                 </div>
                  <div className="spacer-inline">
                    <dt className="ft-wt">Customer:</dt>
                    <dd className="sp-margin12 sp-mx7">
                      {sharedObject?.userDeleteActivity?.VendorName
                        ? sharedObject?.userDeleteActivity?.VendorName
                        : null}
                    </dd>
                  </div>
              </dl>
            </>
          )}
          <SharedMsg />
        </section>
        <section className="grid-layout">
          {userObj?.length > 0 ? (
            <div id="SentMessageReport">
              <DataTable
                value={userObj}
                aria-label="Delete Activities Report"
                rows={25}
                paginator
                selectionPageOnly
                rowsPerPageOptions={[25, 50, 75]}
                tableStyle={{ minWidth: "50rem" }}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                dataKey="Id"
                columnResizeMode="expand"
                resizableColumns
                scrollable
                sortField="dateSent"
                sortOrder={-1}
              >
                {reportName !== "UserAccountDeleted" ? (
                  <Column field="eventValue" header="Direct Email" className="print-col" sortable ></Column>
                ) : null}
                {reportName === "OrganizationEmailDeleted" ? (
                  <Column field="organizationName" header="Organization" className="print-col" sortable ></Column>
                ) : null}
                {reportName === "OrganizationEmailDeleted" ? null : (
                  <Column field={ reportName === "UserAccountDeleted" ? "eventValue" : "UName" } header="Username" className="print-col" sortable body={UserNameDisplay} ></Column>
                )}
                <Column field="eventDomain" header="Domain" className="print-col" sortable ></Column>
                <Column field="note" header="Reason" className="print-col" sortable ></Column>
                <Column field="timeStamp" header="Deleted" className="w-md7" sortable body={deletedDate} ></Column>
                <Column field="actor" header="Deleted By" className="print-col" sortable ></Column>
              </DataTable>
            </div>
          ) : (
            <div 
                className="empty-grid"
                role="status"
                aria-live="polite"
                aria-atomic="true"
            >
              There are currently no search results.
            </div>
          )}
        </section>
     
        {processing && (
          <div 
            className="loader-container" 
            role="status" 
            aria-live="polite" 
            aria-atomic="true"
            aria-labelledby="delete-activity-loader"
          >
            <div className="spinner" aria-hidden="true"></div>
            <div className="loading-text" id="delete-activity-loader">{loadingText}</div>
        </div>
        )}
      </div>
    </main>
  );
};

export default ListUserDeleteActivity;
